/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uVolumeThree = A4uVolumeThree;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uVolumeThree(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M6.74545,12.07316H1a1,1,0,0,0-1,1V22.9964a1,1,0,0,0,1,1H6.74545a1.42873,1.42873,0,0,1,.93031.34466L14.80606,31.6A.72683.72683,0,0,0,16,31.02868V5a.72576.72576,0,0,0-1.19394-.57132L7.67879,11.72851A1.43664,1.43664,0,0,1,6.74545,12.07316Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M22.04042,17.99962a6.936,6.936,0,0,1-1.40767,4.19216.98129.98129,0,0,0,.08672,1.28843l.016.016a.99137.99137,0,0,0,1.48642-.08987,8.95422,8.95422,0,0,0-.02641-10.85324.99115.99115,0,0,0-1.484-.087l-.01564.01564a.98238.98238,0,0,0-.0844,1.29259A6.94427,6.94427,0,0,1,22.04042,17.99962Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M28.04042,17.99962a12.93661,12.93661,0,0,1-3.11586,8.43581.97229.97229,0,0,0,.06336,1.31658l.01412.01416a1.00264,1.00264,0,0,0,1.47436-.06868,14.98,14.98,0,0,0-.02659-19.42971.99913.99913,0,0,0-1.46872-.07138l-.01452.01454a.977.977,0,0,0-.06579,1.323A12.9392,12.9392,0,0,1,28.04042,17.99962Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M34.04042,17.99962a18.92,18.92,0,0,1-4.82353,12.642,1,1,0,0,0,.02366,1.37522l.01484.0149a.98091.98091,0,0,0,1.42183-.02312,20.862,20.862,0,0,0,5.3056-14.009A20.86778,20.86778,0,0,0,30.65651,3.96487a.98479.98479,0,0,0-1.423-.02035l-.015.015a.99616.99616,0,0,0-.0206,1.37464A18.92335,18.92335,0,0,1,34.04042,17.99962Z"
  }));
}